import { CSSProperties } from "react";
import { SwitchProps } from "react-aria-components";

export enum IMDSSwitchVariant {
  WHITE = "white",
  BLACK = "black",
  GREEN = "green",
  GREY = "grey",
  PURPLE = "purple",
  TOGGLE = "toggle",
}

export interface IMDSSwitchProps extends SwitchProps {
  label?: string | React.ReactNode;
  style?: CSSProperties;
  variant?: IMDSSwitchVariant;
}
